/**
 * Strip HTML and return plain text.
 * - Preserves paragraph and <br> line breaks when preserveLineBreaks=true.
 * - Uses DOM (safe decoding of HTML entities).
 */
export function stripHtmlTags(html: string, preserveLineBreaks = true): string {
    if (!html) return '';

    // Insert safe newline placeholders for common block elements

    if (preserveLineBreaks) {
        html = html.replace(/<\/p>\s*<p>/gi, '\n');
        html = html.replace(/<\/?\s*br\s*\/?>/gi, '\n\n');
        html = html.replace(
            /<\/(div|li|h[1-6]|tr|ul|ol|section|article|header|footer)>/gi,
            '$&\n',
        );
    }

    // Create a temporary DOM node to decode HTML entities safely

    // Why this approach is better than pure regex
    // A naive regex like <[^>]*> will remove tags, but it won’t:
    // decode entities (&nbsp;, &#8211;, etc.)
    // preserve line breaks correctly
    // handle nested or malformed HTML safely
    // By leveraging the browser’s built-in HTML parser (innerHTML → textContent), you get:
    // ✅ Safe entity decoding
    // ✅ No risk of partial tags or broken matches
    // ✅ Clean, readable text output
    const container =
        typeof document !== 'undefined' ? document.createElement('div') : null;

    if (container) {
        container.innerHTML = html;
        // textContent gives us the decoded plain text
        const text = container.textContent ?? container.innerText ?? '';
        // Normalize multiple consecutive newlines/spaces a bit and trim
        return text
            .replace(/\r\n/g, '\n')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }

    // Fallback (shouldn't happen in browser): simple regex strip (no entity decoding)
    return html
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
